export default __webpack_public_path__ + "static/media/statsBody.ab5d7dac.jpg";